import { getAPIEndpoint } from "./Utils"
const REACT_SP_API_URL = `${getAPIEndpoint()}/api/service-portal`
const REACT_PORTAL_API_URL = (env) => `https://${env == "prod" ? "portalone" : "stgportalone"}.processonepayments.com`
const REACT_MA_API_URL = `${getAPIEndpoint()}/api/my-account`
const REACT_APP_API_URL = `${getAPIEndpoint()}/api/app`
const REACT_ONEINC_URL = `${getAPIEndpoint()}/api/main`
// const REACT_APP_GW_API = 'https://cure-prod.xi-1-us-west-2.guidewire.net/coreapi/v5'
const PORTAL_ONE_API_URL =
  "https://stgportalone.processonepayments.com/Api/Api";

export const oneincEndpoint = {
  getUseGenesysWebMessaging: {
    method: "POST",
    url: `${REACT_ONEINC_URL}/getUseGenesysWebMessaging`
  },
  loadPaymentFromToken: {
    method: "POST",
    url: `${REACT_ONEINC_URL}/LoadPaymentFromToken`
  },
  loadPaymentFromShortcode: {
    method: "POST",
    url: `${REACT_ONEINC_URL}/LoadPaymentFromShortcode`
  },
  getPaymentInfo: {
    method: "POST",
    url: `${REACT_ONEINC_URL}/GetPaymentInfo`
  },
  getQuotePaymentInfo: {
    method: "POST",
    url: `${REACT_ONEINC_URL}/GetQuotePaymentInfo`
  },
  retrieveOneIncSessionID: {
    method: "POST",
    url: `${REACT_ONEINC_URL}/RetrieveOneIncSessionID`
  },
  enrollAutoPay: {
    method: "POST",
    url: `${REACT_ONEINC_URL}/EnrollAutoPay`
  },
  updateAutoPay: {
    method: "POST",
    url: `${REACT_ONEINC_URL}/UpdateAutoPay`
  },
  cancelAutoPay: {
    method: "POST",
    url: `${REACT_ONEINC_URL}/CancelAutoPay`
  },
  logDownPayment: {
    method: "POST",
    url: `${REACT_ONEINC_URL}/LogDownPayment`
  },
  logPayment: {
    method: "POST",
    url: `${REACT_ONEINC_URL}/LogPayment`
  },
  logMultiplePayments: {
    method: "POST",
    url: `${REACT_ONEINC_URL}/LogMultiplePayments`
  },
  logPBTStatus: {
    method: "POST",
    url: `${REACT_ONEINC_URL}/LogPBTStatus`
  },
  createBindToken: {
    method: "POST",
    url: `${REACT_ONEINC_URL}/CreateBindToken`
  }
}

export const portalOne = {
  portalOneAuthKey: (env) =>
    env == "prod"
      ? "F605DF6A-5707-4A00-8A1E-0FE743EAD76B"
      : "D2D344B8-8F34-4F95-9A81-976E8195BBFC",
  authKey: (env) =>
    env == "prod"
      ? "f8e7ef9c-e029-44f9-9e29-41e83cc50a7e"
      : "b0cffc04-1846-4ddb-bb60-46d6a0bd53a9",

  getCustomerId: {
    method: "POST",
    url: (env) => `${REACT_PORTAL_API_URL(env)}/Api/Api/Customer/CreateAccount`,
  },

  getPaymentMethod: {
    method: "POST",
    url: (env) => `${REACT_PORTAL_API_URL(env)}/Api/Api/PaymentMethod/Get`,
  },

  enrollAutoPay: {
    method: "POST",
    url: (env) =>
      `${REACT_PORTAL_API_URL(env)}/InstallmentsOne/api/InstallmentPlan/Enroll`,
  },

  checkAutoPay: {
    method: "POST",
    url: (env) =>
      `${REACT_PORTAL_API_URL(env)}/InstallmentsOne/api/InstallmentPlan/GetPaymentMethodInstallmentsInfoByToken`,
  },

  getActiveInstallmentPlan: {
    method: "POST",
    url: (env) =>
      `${REACT_PORTAL_API_URL(env)}/InstallmentsOne/api/InstallmentPlan/GetActiveInstallmentPlanByPolicyRefNumber`,
  },

  // checkPBTStatus: {
  //   method: "POST",
  //   url: (env) =>
  //     `${REACT_PORTAL_API_URL(env)}/Communication/api/Subscriptions/GetSubscriptionDetails`,
  // },
  
  checkPBTStatus: {
    method: "POST",
    url: `${REACT_MA_API_URL}/CheckPBTStatus`,
  },
};

export const paymentEndpoint = {
  getPaymentInfo: {
    method: 'POST',
    url: `${REACT_MA_API_URL}/GetPaymentInfo`,
    // query: 'PaymentCenter.sql',
  },

  logPaymentError: {
    method: 'POST',
    url: `${REACT_ONEINC_URL}/LogPaymentError`
  },

  getLastPayment: {
    method: "POST",
    url: `${REACT_APP_API_URL}/RunQuery`,
    query: "PaymentCenterLast.sql",
  },

  getPaymentHistory: {
    method: 'POST',
    url: `${REACT_MA_API_URL}/GetPaymentHistory`,
  },

  getPaperlessBillHistory: {
    method: "POST",
    url: `${REACT_APP_API_URL}/RunQuery`,
    query: "GetPaperlessBillHistory.sql",
  },

  getInstallmentBill: {
    method: "POST",
    url: `${REACT_MA_API_URL}/GetInstallmentBill`,
  },

  registerForBilling: {
    method: "POST",
    url: `${REACT_MA_API_URL}/RegisterForBilling`,
  },

  getPaymentPdf: {
    method: "POST",
    url: `${REACT_APP_API_URL}/GetPdf`,
    endpoint: `https://{{GW_DOMAIN}}.guidewire.net/coreapi/v5/policies/{{systemId}}/documents/{{id}}/content`,
  },

  getAllPolicyDocs: {
    method: "POST",
    url: `${REACT_APP_API_URL}/RunQuery`,
    query: "GetAllPolicyDocs.sql",
  },

  getDocuments: {
    method: "POST",
    url: `${REACT_MA_API_URL}/GetDocuments`,
  },

  getDocument: {
    method: "POST",
    url: `${REACT_MA_API_URL}/DownloadDocument`,
  },

  GetArchive: {
    method: "POST",
    url: `${REACT_MA_API_URL}/GetArchive`,
  },

  GetAutoPayStatus: {
    method: "POST",
    url: `${REACT_MA_API_URL}/GetAutoPayStatus`,
  },
  GetEnvironmentSettings: {
    method: "POST",
    url: `${REACT_MA_API_URL}/GetEnvironmentSettings`,
  },
};

export const maintenanceEndpoint = {
  getWebsiteStatus: {
    method: 'POST',
    url: `${REACT_ONEINC_URL}/CheckWebsiteMaintenance`
  },
  getWebsiteMessage: {
    method: 'POST',
    url: `${REACT_ONEINC_URL}/GetWebsiteMaintenanceMessage`
  }
}